// Imports
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html, body { \n    height: 100%; \n}\n\nbody { \n    margin: 0; \n    font-family: Roboto, \"Helvetica Neue\", sans-serif; \n}\n", "",{"version":3,"sources":["webpack://src/styles.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,iDAAiD;AACrD","sourcesContent":["html, body { \n    height: 100%; \n}\n\nbody { \n    margin: 0; \n    font-family: Roboto, \"Helvetica Neue\", sans-serif; \n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
